import { DependencyStatusCarrier, dependencyStatus } from './aiDependencyStatus'

// Application Insights auto-tracks XHR/fetch dependencies. AbortController
// cancellations surface there as resultCode "0", indistinguishable from real
// network failures. The axios catch-path knows when a request was canceled,
// so we mark it here and drop the matching dependency telemetry envelope.

const canceledUrls = new Map<string, number>()
const EXPIRY_MS = 5000

export function markCanceled(url: string | undefined): void {
    if (!url) {
        return
    }
    canceledUrls.set(url, (canceledUrls.get(url) ?? 0) + 1)
    setTimeout(() => {
        const n = canceledUrls.get(url) ?? 0
        if (n <= 1) {
            canceledUrls.delete(url)
        } else {
            canceledUrls.set(url, n - 1)
        }
    }, EXPIRY_MS)
}

export function isCanceledDependency(envelope: { baseType?: string; baseData?: DependencyStatusCarrier & { name?: string } }): boolean {
    if (envelope?.baseType !== 'RemoteDependencyData'){
        return false
    }
    const data = envelope.baseData
    if (dependencyStatus(data) !== '0'){
        return false
    }
    const name = data?.name ?? ''
    for (const [url, count] of canceledUrls) {
        if (name.includes(url)) {
            if (count <= 1) {
                canceledUrls.delete(url)
            } else {
                canceledUrls.set(url, count - 1)
            }
            return true
        }
    }
    return false
}
